module.exports = "/packs/images/social_enerprise_logo_black--mobile~6b8452b1abe2d0a0c1e7de8998020023.gif";